import './offline-ribbon.scss';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

@Component({
    template: require('./offline-ribbon.html'),
})
export class OfflineRibbon extends ReactiveVue {
    public onLine = true;

    private running = false;

    public created() {
        this.running = true;
        this.onFrame();
    }

    public beforeDestroy() {
        this.running = false;
    }

    private onFrame() {
        this.onLine = window.navigator.onLine;

        if (this.running) {
            requestAnimationFrame(this.onFrame);
        }
    }

    private checkOnLine() {
        this.onLine = window.navigator.onLine;
    }
}
